export default __webpack_public_path__ + "3d010555acc4900e72fc646ffbdb0dbb.png";